import React from 'react';
import { useNavigate } from 'react-router-dom';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button } from '@mui/material';

function Footer(props) {
    const navigate = useNavigate();

    return(
        
    <div className="footerContainer">
        <img src="https://odontoluzzi.com.br/images/pattern.svg" className='patternFooterMob' style={{display:'none'}}/>
        <div className='footerContent'>
            <div className="footerL from-left">
                <img src="https://odontoluzzi.com.br/images/logoFooter.svg" className='logoFooter'/>
            </div>
            <div className="footerR from-right">
                <div className='footerInfos'>
                    <div className="contato">
                        <div className="subTitle">Contato</div>
                        <div className="footerTitle">(45) 3225-2800</div>
                    </div>
                    <div className="endereco">
                        <div className="subTitle">Endereço</div>
                        <div className="footerTitle">R. Rio de Janeiro, 1355
                        Centro, Cascavel</div>
                    </div>
                    <div className="horario">
                        <div className="subTitle">Atendimento Segunda à Sexta</div>
                        <div className="footerTitle">8:30 às 12h <br/>13:30 às 18:30</div>
                        <div className="subTitle">Atendimento aos Sábados</div>
                        <div className="footerTitle">8h às 12h</div>
                    </div>
                    <div className="redeSociais">
                        <div className="subTitle">Redes Sociais</div>
                        <a href='https://instagram.com/odontoluzzi' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}><InstagramIcon sx={{ fontSize:32, color:'#041819', cursor:'pointer', '&:hover':{color:'#B08E44'}}}/></a>
                        <a href='https://www.facebook.com/profile.php?id=100063743283039' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}><FacebookRoundedIcon sx={{ fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                        <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}><WhatsAppIcon sx={{ fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                    </div>
                    <div className="trabalheConosco">
                        <div className="subTitle">Trabalhe Conosco</div>
                        <a href='https://linkedin.com'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#041819" className="bi bi-linkedin" viewBox="0 0 16 16">
                                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                            </svg>
                        </a>
                        <a href='https://infojobs.com'>
                            <svg xmlns="http://www.w3.org/2000/svg" style={{marginLeft:'10px'}} width='30' height='30' viewBox="0 0 138 136.1">
                                <path d="M114.9 0H23.1C10.3 0 0 10.3 0 23.1V113c0 12.7 10.3 23.1 23.1 23.1h91.8c12.8 0 23.1-10.3 23.1-23.1V23.1C138 10.3 127.7 0 114.9 0M45.3 90.5c-.7 0-1.3-.4-1.3-1.1l.1-.2 7.1-59.3c.1-.7.2-1 1-1.1h12c.6 0 .9.4.9 1v.2l-7.2 59.3c-.1.7-.7 1.2-1.5 1.2zm40.9.8c-1.6 12.9-9.7 15.9-19.4 15.9-5.7 0-6.5-.2-8-.4-.7-.1-1.5-.2-1.5-1.3v-.5l.6-4.8c.2-1.4.7-1.7 2-1.7 1.2-.1 2.7-.1 4.5-.2 4.3-.2 7.3-.6 8.1-6.7L80 30c.1-.7.7-1.1 1.4-1.2l11.3.2h.2c.7 0 1 .4 1 1z" fill="#041819"/>
                            </svg>
                        </a>
                    </div>
                    <a href="https://odontoluzzi.com.br/Login">
                    <Button sx={{color:'#FFF', height:30, width:100, backgroundColor:'#B08E44', borderRadius:'5px', fontSize:'14px', fontWeight:'bold', textTransform: 'none','&:hover': { backgroundColor:'#041819'}}}>Admin</Button>
                    </a>
                </div>
                
                <img src="https://odontoluzzi.com.br/images/pattern.svg" className='patternFooter'/>
            </div>
        </div>
        <div className='footerBar'>
            <div className="rights">© 2025 - Odonto Luzzi - Todos os direitos reservados - Responsável Técnico CRO-PR 12928.</div>
            <div className='dev'>
                Desenvolvido por:
                <a className="developer" href='https://sigmasystems.com.br'><div style={{display:'flex'}}><img src="https://odontoluzzi.com.br/images/logoSigma.svg" className="logoSigma" alt="sigmaLogo"></img></div></a>
            </div>
        </div>
    </div>
    
    )
};
export default Footer;